import React from "react";

const TakeARightStepForYourLife = () => {
	return (
		<section className="elementor-section elementor-top-section elementor-element elementor-element-e514609 elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="e514609" data-element_type="section" data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;,&quot;background_background&quot;:&quot;classic&quot;}">
			<div className="elementor-background-overlay"></div>
			<div className="elementor-container elementor-column-gap-no">
				<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6be1ebd" data-id="6be1ebd" data-element_type="column">
					<div className="elementor-widget-wrap elementor-element-populated">
						<div className="elementor-element elementor-element-6fae55c elementor-widget elementor-widget-dc_element_easy_steps" data-id="6fae55c" data-element_type="widget" data-widget_type="dc_element_easy_steps.default">
							<div className="elementor-widget-container">
								<div className="dc-aboutstep dc-easy-steps dc-haslayout dynamic-secton-510853">
									<div className="container">
										<div className="row justify-content-center align-self-center">
											<div className="col-xs-12 col-sm-12 col-md-8 push-md-2 col-lg-8 push-lg-2">
												<div className="dc-sectionhead dc-text-center">
													<div className="dc-sectiontitle">
														<h2>
															<span>Make A Smart Choice</span>
															Take A Right Step <em>For Your Life</em>											</h2>
													</div>
													<div className="dc-description"><p>At MeddyList, we help you connect with trusted healthcare professionals. Your well-being is our priority, and every step you take with us is a step toward better health and peace of mind.</p></div>
												</div>
											</div>
											<div className="dc-welcome-holder dc-bksteps">
												<div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-left">
													<div className="dc-welcomecontent">
														<figure className="dc-welcomeimg">
															<img decoding="async" width="" height="" src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/08/img-01-1.jpg" alt="Search Best Online" />
														</figure>
														<div className="dc-title">
															<h3><span>Search Best Online</span>Professional</h3>
														</div>
														<div className="dc-description"><p>Easily search and connect with trusted healthcare providers based on your specific needs.</p></div>
													</div>
												</div>
												<div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-left">
													<div className="dc-welcomecontent">
														<figure className="dc-welcomeimg">
															<img decoding="async" width="" height="" src="https://amentotech.com/projects/doctreat/wp-content/uploads/2019/08/img-02-1.jpg" alt="Get Instant" />
														</figure>
														<div className="dc-title">
															<h3><span>Get Instant</span>Appointment</h3>
														</div>
														<div className="dc-description"><p>Book appointments quickly and effortlessly—no long waits or unnecessary delays.</p></div>
													</div>
												</div>
												<div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-left">
													<div className="dc-welcomecontent">
														<figure className="dc-welcomeimg">
															<img decoding="async" width="" height="" src="https://amentotech.com/projects/doctreat/wp-content/uploads/2019/08/img-03.jpg" alt="Leave Your" />
														</figure>
														<div className="dc-title">
															<h3><span>Leave Your</span>Feedback</h3>
														</div>
														<div className="dc-description"><p>Help others make informed decisions by sharing your experience.</p></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default TakeARightStepForYourLife;
